<div class="timeout-modal" role="dialog">
  <gstar-header-modal [id]="modalId" [hasCloseButton]="false">
    <h4 class="fs-4">{{ 'timeoutModal.title' | translate }}</h4>
  </gstar-header-modal>
  <gstar-body-modal>
    <p class="text-center fs-5">
      {{ 'timeoutModal.paragraphFragment1' | translate }}
      <span class="ap-text-color-text-primary">
        {{ timeCounter() }}
        {{ 'timeoutModal.seconds' | translate }}
      </span>
    </p>
    <p class="ap-font-14 mt-2">
      {{ 'timeoutModal.click' | translate }}
      <span class="fw-bold text-uppercase">{{
        'timeoutModal.continue' | translate
      }}</span>
      {{ 'timeoutModal.paragraphFragment2' | translate }}
      <span class="fw-bold text-uppercase">{{
        'timeoutModal.logOff' | translate
      }}</span>
      {{ 'timeoutModal.paragraphFragment3' | translate }}
    </p>
  </gstar-body-modal>
  <gstar-footer-modal
    [id]="modalId"
    [primaryButtonLabel]="'timeoutModal.continue' | translate | uppercase"
    [secondaryButtonLabel]="'timeoutModal.logOff' | translate | uppercase" />
</div>
